import React from 'react';

import {
  Section,
  Image,
  Button,
  Article,
  ArticleType,
} from 'components/shared';
import { IRelatedContentProps } from './RelatedContent.types';
import styles from './RelatedContent.module.scss';

const RelatedContent: React.FC<IRelatedContentProps> = (props) => {
  const {
    title,
    iconImage,
    sideImage,
    mainArticle,
    secondaryArticles = [],
    ctaText,
    ctaUrl,
  } = props;
  const otherArticles = secondaryArticles.map((article) => (
    <li className={styles.relatedContent__secondaryArticle} key={article.title}>
      <Article
        type={ArticleType.Secondary}
        classes={{
          article__title: styles.relatedContent__secondaryArticleTitle,
        }}
        {...article}
      />
    </li>
  ));

  return (
    <Section
      classes={{
        section: styles.relatedContent,
        section__headerText: styles.relatedContent__headerText,
      }}
      title={title}
      image={iconImage}
    >
      <div className={styles.relatedContent__content}>
        {mainArticle && (
          <Article
            classes={{
              article: styles.relatedContent__mainArticle,
              article__title: styles.relatedContent__mainArticleTitle,
            }}
            type={ArticleType.Main}
            {...mainArticle}
          />
        )}
        {otherArticles.length > 0 && (
          <ul className={styles.relatedContent__secondaryArticles}>
            {otherArticles}
          </ul>
        )}
        {sideImage && (
          <Image className={styles.relatedContent__sideImage} {...sideImage} />
        )}
        <div className={styles.relatedContent__buttonWrapper}>
          {ctaText && (
            <Button className={styles.relatedContent__button} link={ctaUrl}>
              {ctaText}
            </Button>
          )}
        </div>
      </div>
    </Section>
  );
};

export default RelatedContent;
